import { render, staticRenderFns } from "./vendor-contact-flyout.vue?vue&type=template&id=94b90220&scoped=true&"
import script from "./vendor-contact-flyout.vue?vue&type=script&lang=js&"
export * from "./vendor-contact-flyout.vue?vue&type=script&lang=js&"
import style0 from "./vendor-contact-flyout.vue?vue&type=style&index=0&id=94b90220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b90220",
  null
  
)

export default component.exports